import React, { useState, useEffect } from "react";
import { InputNumber } from "antd";
import moment from "moment";
import swal from "sweetalert";
import DEATH_API from "../../../../../../../apis/death.api";
import NewLoader from "../../../../../../../components/styled-components/loader/NewLoader";
import BUDGET_API from "../../../../../../../apis/budget.api";
import { ToolTipCreator } from "../../../../../../../helpers/ToolTipCreator";

export const CreateBudget = ({ categories, chartData,getAll }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [monthsBudgetData, setMonthsBudgetData] = useState(null);
  const [prefillBudget, setPrefillBudget] = useState(false); // Track checkbox state
  const createBudgetTabs = [
    {
      id: 1,
      name: "Monthly",
    },
    {
      id: 2,
      name: "One-Time",
    },
  ];

  const getNext12Months = () => {
    const months = [];
    const currentMonth = moment().add(1, "month"); // Start from next month
    for (let i = 0; i < 12; i++) {
      months.push(currentMonth.clone().add(i, "month").format("MMM YYYY"));
    }
    return months;
  };

  const getPreviuos12Months = () => {
    const months = [];
    for (let i = 0; i < 12; i++) {
      months.push(i); // Here i will represent month index (0 to 11) for 12 months
    }
    return months; // This should return an array like [0, 1, 2, ..., 11] for 12 months
  };
  console.log("chartData", chartData);
  // const getAllFilterBudgetsMonthsCategory = async () => {
  //   try {
  //     setLoading(true);
  //     const date = moment();
  //     let newFormData = {};

  //     // Generate an array of promises for the last 12 months
  //     const monthsPromises = getPreviuos12Months().map((month) => {
  //       const startDate = date
  //         .clone()
  //         .subtract(month, "months")
  //         .startOf("month")
  //         .format("YYYY-MM-DD");
  //       const endDate = date
  //         .clone()
  //         .subtract(month, "months")
  //         .endOf("month")
  //         .format("YYYY-MM-DD");

  //       // Return the promise for fetching the budget data
  //       return BUDGET_API.fetchAllBudget(startDate, endDate, "month")
  //         .then((data) => {
  //           const monthName = date
  //             .clone()
  //             .subtract(month, "months")
  //             .format("MMM"); // Example: Jan
  //             const monthNameForMatch = date
  //             .clone()
  //             .subtract(month, "months")
  //             .format("MMMM"); // Example: Jan
  //           const year = date
  //             .clone()
  //             .subtract(month, "months")
  //             .add(1, "year")
  //             .format("YYYY");
  //           const monthKey = `${monthName} ${year}`; // Combined key: "Jan-2025"

  //           const categorizedData =
  //             (data.categorized && data.categorized) || [];
  //           const matchingCategory = categorizedData.find((item) => {
  //             return item.budgetCategory.subCategories.some(
  //               (subCategory) => subCategory.name === monthNameForMatch
  //             );
  //           });

  //           const amountForMonth = matchingCategory
  //             ? matchingCategory.amount
  //             : 0;

  //           return { key: `amount-${monthKey}`, value: amountForMonth };
  //         })
  //         .catch(() => {
  //           const monthName = date
  //             .clone()
  //             .subtract(month, "months")
  //             .format("MMM");
  //           const year = date
  //             .clone()
  //             .subtract(month, "months")
  //             .add(1, "year")
  //             .format("YYYY");
  //           const monthKey = `${monthName} ${year}`;
  //           return { key: `amount-${monthKey}`, value: 0 };
  //         });
  //     });

  //     // Use Promise.all to wait for all promises to resolve
  //     const results = await Promise.all(monthsPromises);

  //     console.log("results", results);

  //     // Merge results into newFormData
  //     results.forEach(({ key, value }) => {
  //       newFormData[key] = value;
  //     });
  //     console.log("newFormData", newFormData);
  //     // Update the formData state
  //     setFormData((prev) => ({
  //       ...prev,
  //       ...newFormData,
  //     }));

  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  const getAllFilterBudgetsMonthsCategory = async () => {
    try {
      setLoading(true);
      let newFormData = {};
      const currentDate = moment();
      for (let monthOffset = 0; monthOffset < 12; monthOffset++) {
        const targetDate = currentDate.clone().add(monthOffset + 1, "months");
        const monthKey = targetDate.format("MMM YYYY");
        const chartMonthKey = targetDate.subtract(1, "years").format("YYYY-MM"); // Shift backward by a year

        const matchingData = chartData.find(
          (item) => item.month === chartMonthKey
        );

        const totalExpense =
          matchingData && matchingData.total_expenses
            ? parseFloat(Math.abs(matchingData.total_expenses))
            : 0; // Default if no match

        newFormData[`amount-${monthKey}`] = totalExpense;
      }
      if (chartData && chartData.length === 0) {
        newFormData = {};
        for (let monthOffset = 0; monthOffset < 12; monthOffset++) {
          const targetDate = currentDate.clone().add(monthOffset + 1, "months");
          const monthKey = targetDate.format("MMM YYYY");
          newFormData[`amount-${monthKey}`] = 0;
        }
      }

      setFormData((prev) => ({
        ...prev,
        ...newFormData,
      }));

      console.log("newFormData", newFormData);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    setPrefillBudget(e.target.checked);
    if (e.target.checked) {
      getAllFilterBudgetsMonthsCategory(); // Fetch and prefill previous 12 months
    } else {
      setFormData({}); // Clear form if checkbox is unchecked
    }
  };
  // const handleCreateBudget = async () => {
  //   console.log("formdatatata",formData)
  //   if (!formData || Object.keys(formData).length === 0) {
  //   swal("Error", "Please provide all the required data", "error");
  //   return;
  // }

  //   let categoryId = null;
  //   const categoryName = "Month";
  //   if (!formData.categoryId) {
  //     const category =
  //       categories &&
  //       categories.find((item) => item.categoryName === categoryName);
  //     categoryId = category && category.id;
  //   }

  //   const months = getNext12Months();
  //   const payloads = [];

  //   if (selectedIndex === 0) {
  //     // Monthly - Create budget for 12 months
  //     months.forEach((month) => {
  //       const [subCategoryName, endDate] = [
  //         month,
  //         moment(month, "MMM YYYY").endOf("month").format("MM/DD/YYYY"),
  //       ];
  //       payloads.push({
  //         amount: formData[`amount-${month}`] || 0, // Amount for each month
  //         categoryId,
  //         categoryName: categoryName,
  //         endDate,
  //         subCategory: subCategoryName,
  //         subCategoryId: null, // Set it if needed
  //       });
  //     });
  //   } else {
  //     // One-Time - Create budget for all next months
  //     const oneTimePayload = months.map((month) => {
  //       const endDate = moment(month, "MMM YYYY")
  //         .endOf("month")
  //         .format("MM/DD/YYYY");
  //       return {
  //         amount: formData.amount,
  //         categoryId,
  //         categoryName: categoryName,
  //         endDate,
  //         subCategory: month,
  //         subCategoryId: null, // Set it if needed
  //       };
  //     });
  //     payloads.push(...oneTimePayload);
  //   }

  //   try {
  //     setLoading(true);
  //     const responses = await Promise.all(
  //       payloads.map((payload) => DEATH_API.createBudget(payload))
  //     );

  //     const successCount = responses.filter(
  //       (res) => res && res.status === 200
  //     ).length;
  //     if (successCount === payloads.length) {
  //       swal("Success", "All budgets created successfully!", "success");
  //     } else {
  //       swal(
  //         "Warning",
  //         `${successCount} budgets created successfully, but some failed.`,
  //         "warning"
  //       );
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error creating budgets:", error);
  //     swal("Error", "Failed to create budgets.", "error");
  //     setLoading(false);
  //   }
  //   setFormData({});
  // };
//   const handleCreateBudget = async () => {
//     console.log("formData:", formData);
//     if (!formData || Object.keys(formData).length === 0) {
//       swal("Error", "Please provide all the required data", "error");
//       return;
//     }

//     let categoryId = formData.categoryId || null;
//     const categoryName = "Month";
//     const category =
//       categories &&
//       categories.find((item) => item.categoryName === categoryName);
//     // Fetch categoryId if not provided
//     if (!categoryId) {
//       categoryId = category ? category.id : null;

//       if (!categoryId) {
//         swal("Error", "Invalid or missing category for 'Month'", "error");
//         return;
//       }
//     }

//     const months = getNext12Months(); // Assumes this function returns ["Jan 2025", "Feb 2025", ...]
//     const payloads = [];

//     if (selectedIndex === 0) {
//       // Monthly budget for the next 12 months
//       months.forEach((month) => {
//         const endDate = moment(month, "MMM YYYY")
//           .endOf("month")
//           .format("MM/DD/YYYY");
//         const fullMonthName = moment(month, "MMM YYYY").format("MMMM");

//         const subCategory =
//           category &&
//           category.subCategories &&
//           category.subCategories.find((item) => item.name === fullMonthName);
//         const subCategoryId = subCategory ? subCategory.id : null;

//         const amount = formData[`amount-${month}`] || 0;

//         if (amount > 0) {
//           payloads.push({
//             amount,
//             categoryId,
//             categoryName,
//             endDate,
//             subCategory: fullMonthName,
//             subCategoryId,
//           });
//         }
//       });
//     } else {
//       // One-time budget for the next 12 months
//       months.forEach((month) => {
//         const endDate = moment(month, "MMM YYYY")
//           .endOf("month")
//           .format("MM/DD/YYYY");
//         const fullMonthName = moment(month, "MMM YYYY").format("MMMM");

//         const subCategory =
//           category &&
//           category.subCategories &&
//           category.subCategories.find((item) => item.name === fullMonthName);
//         const subCategoryId = subCategory ? subCategory.id : null;

//         if (formData.amount > 0) {
//           payloads.push({
//             amount: formData.amount,
//             categoryId,
//             categoryName,
//             endDate,
//             subCategory: fullMonthName,
//             subCategoryId,
//           });
//         }
//       });
//     }

//     if (payloads.length === 0) {
//       swal("Error", "No budgets to create. Please check your inputs.", "error");
//       return;
//     }
// console.log("payloads",payloads)
//     try {
//       setLoading(true);

//       // Send API requests for each payload
//       const responses = await Promise.all(
//         payloads.map((payload) => DEATH_API.createBudget(payload))
//       );

//       const successCount = responses.filter(
//         (res) => res && res.status === 200
//       ).length;
//       const errorCount = payloads.length - successCount;

//       if (successCount === payloads.length) {
//         swal("Success", "All budgets created successfully!", "success");
//       } else if (successCount > 0) {
//         swal(
//           "Warning",
//           `${successCount} budgets created successfully, but ${errorCount} failed.`,
//           "warning"
//         );
//       } else {
//         swal(
//           "Error",
//           "Failed to create all budgets. As already created for Next 12 Months",
//           "error"
//         );
//       }
//     } catch (error) {
//       console.error("Error creating budgets:", error);
//       swal("Error", "An error occurred while creating budgets.", "error");
//     } finally {
//       setLoading(false);
//       setFormData({});
//       setPrefillBudget(false);
//     }
//   };

  // const handleCreateBudget = async () => {
  //   console.log("formData:", formData);
  //   if (!formData || Object.keys(formData).length === 0) {
  //     swal("Error", "Please provide all the required data", "error");
  //     return;
  //   }
  
  //   let categoryId = formData.categoryId || null;
  //   const categoryName = "Month";
  //   const category =
  //     categories &&
  //     categories.find((item) => item.categoryName === categoryName);
  
  //   // Fetch categoryId if not provided
  //   if (!categoryId) {
  //     categoryId = category ? category.id : null;
  //     if (!categoryId) {
  //       swal("Error", "Invalid or missing category for 'Month'", "error");
  //       return;
  //     }
  //   }
  
  //   const months = getNext12Months(); // ["Jan 2025", "Feb 2025", ...]
  //   const existingBudgets = monthsBudgetData && monthsBudgetData;
  
  //   const payloadsToCreate = [];
  //   const payloadsToUpdate = [];
  
  //   if (selectedIndex === 0) {
  //     // Monthly budget for each month separately
  //     months.forEach((month) => {
  //       const fullMonthName = moment(month, "MMM YYYY").format("MMMM");
  //       const endDate = moment(month, "MMM YYYY").endOf("month").format("MM/DD/YYYY");
  //       const subCategory =
  //         category &&
  //         category.subCategories &&
  //         category.subCategories.find((item) => item.name === fullMonthName);
  //       const subCategoryId = subCategory ? subCategory.id : null;
  
  //       const amount = formData[`amount-${month}`] || 0;
  
  //       if (amount > 0) {
  //         const existingBudget = existingBudgets.find(
  //           (budget) => budget.subCategory === fullMonthName
  //         );
  
  //         if (existingBudget) {
  //           // Update payload for existing budget
  //           if (existingBudget.amount !== amount) {
  //             payloadsToUpdate.push({
  //               id: existingBudget.id,
  //               amount,
  //             });
  //           }
  //         } else {
  //           // Create payload for new budget
  //           payloadsToCreate.push({
  //             amount,
  //             categoryId,
  //             categoryName,
  //             endDate,
  //             subCategory: fullMonthName,
  //             subCategoryId,
  //           });
  //         }
  //       }
  //     });
  //   } else {
  //     // One-time budget applied for all selected months
  //     const amount = formData.amount || 0;
  
  //     if (amount > 0) {
  //       months.forEach((month) => {
  //         const fullMonthName = moment(month, "MMM YYYY").format("MMMM");
  //         const endDate = moment(month, "MMM YYYY").endOf("month").format("MM/DD/YYYY");
  
  //         const subCategory =
  //           category &&
  //           category.subCategories &&
  //           category.subCategories.find((item) => item.name === fullMonthName);
  //         const subCategoryId = subCategory ? subCategory.id : null;
  
  //         const existingBudget = existingBudgets.find(
  //           (budget) => budget.subCategory === fullMonthName
  //         );
  
  //         if (existingBudget) {
  //           // Update payload for existing budget
  //           if (existingBudget.amount !== amount) {
  //             payloadsToUpdate.push({
  //               id: existingBudget.id,
  //               amount,
  //             });
  //           }
  //         } else {
  //           // Create payload for new budget
  //           payloadsToCreate.push({
  //             amount,
  //             categoryId,
  //             categoryName,
  //             endDate,
  //             subCategory: fullMonthName,
  //             subCategoryId,
  //           });
  //         }
  //       });
  //     }
  //   }
  
  //   if (payloadsToCreate.length === 0 && payloadsToUpdate.length === 0) {
  //     swal("Error", "No budgets to create or update. Please check your inputs.", "error");
  //     return;
  //   }
  
  //   console.log("payloadsToCreate", payloadsToCreate, payloadsToUpdate);
  
  //   try {
  //     setLoading(true);
  
  //     // API calls for creation
  //     const createResponses = await Promise.all(
  //       payloadsToCreate.map((payload) => DEATH_API.createBudget(payload))
  //     );
  
  //     // API calls for updates
  //     const updateResponses = await Promise.all(
  //       payloadsToUpdate.map((payload) => BUDGET_API.updateMonthlyBudget(payload))
  //     );
  
  //     const createSuccessCount = createResponses.filter(
  //       (res) => res && res.status === 200
  //     ).length;
  //     const updateSuccessCount = updateResponses.filter(
  //       (res) => res && res.status === 200
  //     ).length;
  
  //     swal(
  //       "Result",
  //       `${createSuccessCount} budgets created, ${updateSuccessCount} budgets updated.`,
  //       "success"
  //     );
  //   } catch (error) {
  //     console.error("Error creating or updating budgets:", error);
  //     swal("Error", "An error occurred while processing budgets.", "error");
  //   } finally {
  //     setLoading(false);
  //     setFormData({});
  //     setPrefillBudget(false);
  //   }
  // };
  const handleCreateBudget = async () => {
    console.log("formData:", formData);
    if (!formData || Object.keys(formData).length === 0) {
      swal("Error", "Please provide all the required data", "error");
      return;
    }
  
    let categoryId = formData.categoryId || null;
    const categoryName = "Month";
    const category =
      categories &&
      categories.find((item) => item.categoryName === categoryName);
  
    // Fetch categoryId if not provided
    if (!categoryId) {
      categoryId = category ? category.id : null;
      if (!categoryId) {
        swal("Error", "Invalid or missing category for 'Month'", "error");
        return;
      }
    }
  
    const months = getNext12Months(); // ["Jan 2025", "Feb 2025", ...]
    const existingBudgets = monthsBudgetData && monthsBudgetData;
  
    const payloadsToCreate = [];
    const payloadsToUpdate = [];
  
    if (selectedIndex === 0) {
      // Monthly budget for each month separately
      months.forEach((month) => {
        const fullMonthName = moment(month, "MMM YYYY").format("MMMM");
        const endDate = moment(month, "MMM YYYY").endOf("month").format("MM/DD/YYYY");
        const subCategory =
          category &&
          category.subCategories &&
          category.subCategories.find((item) => item.name === fullMonthName);
        const subCategoryId = subCategory ? subCategory.id : null;
  
        const amount = formData[`amount-${month}`] || 0;
  
        if (amount > 0) {
          const existingBudget = existingBudgets && existingBudgets.find(
            (budget) => budget.subCategory === fullMonthName
          );
  
          if (existingBudget) {
            // Update payload for existing budget
            if (existingBudget.amount !== parseInt(amount)) {
              payloadsToUpdate.push({
                id: existingBudget.id,
                amount:parseInt(amount),
              });
            }
          } else {
            // Create payload for new budget
            payloadsToCreate.push({
              amount:parseInt(amount),
              categoryId,
              categoryName,
              endDate,
              subCategory: fullMonthName,
              subCategoryId,
            });
          }
        }
      });
    } else {
      // One-time budget applied for all selected months
      const amount = formData.amount || 0;
  
      if (amount > 0) {
        months.forEach((month) => {
          const fullMonthName = moment(month, "MMM YYYY").format("MMMM");
          const endDate = moment(month, "MMM YYYY").endOf("month").format("MM/DD/YYYY");
  
          const subCategory =
            category &&
            category.subCategories &&
            category.subCategories.find((item) => item.name === fullMonthName);
          const subCategoryId = subCategory ? subCategory.id : null;
  
          const existingBudget = existingBudgets.find(
            (budget) => budget.subCategory === fullMonthName
          );
  
          if (existingBudget) {
            // Update payload for existing budget
            if (existingBudget.amount !== amount) {
              payloadsToUpdate.push({
                id: existingBudget.id,
                amount,
              });
            }
          } else {
            // Create payload for new budget
            payloadsToCreate.push({
              amount,
              categoryId,
              categoryName,
              endDate,
              subCategory: fullMonthName,
              subCategoryId,
            });
          }
        });
      }
    }
  
    if (payloadsToCreate.length === 0 && payloadsToUpdate.length === 0) {
      swal("Error", "No budgets to create or update. Please check your inputs.", "error");
      return;
    }
  
    console.log("payloadsToCreate", payloadsToCreate, payloadsToUpdate);
  
    if (payloadsToUpdate.length > 0) {
      swal({
        title: "Are you sure?",
        text: "Adjusting this Budget will override your previous selections.",
        icon: "warning",
        buttons: {
          ok: {
            text: "Ok",
            value: "ok",
            visible: true,
          },
          cancel: {
            text: "Cancel",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
        },
      }).then(async (value) => {
        if (value === "ok") {
          try {
            setLoading(true);
  
            // API calls for creation
            const createResponses = await Promise.all(
              payloadsToCreate.map((payload) => DEATH_API.createBudget(payload))
            );
  
            // API calls for updates
            const updateResponses = await Promise.all(
              payloadsToUpdate.map((payload) => BUDGET_API.updateMonthlyBudget(payload))
            );
  
            const createSuccessCount = createResponses.filter(
              (res) => res && res.status === 200
            ).length;
            const updateSuccessCount = updateResponses.filter(
              (res) => res && res.status === 200
            ).length;
           
            swal(
              "Result",
              `${createSuccessCount} budgets created, ${updateSuccessCount} budgets updated.`,
              "success"
            );
          } catch (error) {
            console.error("Error creating or updating budgets:", error);
            swal("Error", "An error occurred while processing budgets.", "error");
          } finally {
            setLoading(false);
            setFormData({});
            setPrefillBudget(false);
            await getAllBudgetsMonthsCategory();
            await getAll();
          }
        } else {
          console.log("Update canceled");
        }
      });
    } else {
      try {
        setLoading(true);
  
        // API calls for creation
        const createResponses = await Promise.all(
          payloadsToCreate.map((payload) => DEATH_API.createBudget(payload))
        );
  
        const createSuccessCount = createResponses.filter(
          (res) => res && res.status === 200
        ).length;
        
        swal(
          "Result",
          `${createSuccessCount} budgets created.`,
          "success"
        );
      } catch (error) {
        console.error("Error creating budgets:", error);
        swal("Error", "An error occurred while processing budgets.", "error");
      } finally {
        setLoading(false);
        setFormData({});
        setPrefillBudget(false);
        await getAllBudgetsMonthsCategory();
        await getAll();

      }
    }
  };
  

  const getAllBudgetsMonthsCategory = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.clone().startOf("month").format("YYYY-MM-DD"); // Start of the current month
      const endDate = date.clone().add(1, "year").endOf("month").format("YYYY-MM-DD");
      console.log("startDate",startDate,endDate)
      let data = await BUDGET_API.fetchAllBudget(startDate, endDate, "month","false");
      if (data && data.status === 200 && data.categorized) {
        // setBudgetData(data.categorized);

        const structuredData = data.categorized && data.categorized.map((budget) => {
          const totalAmount = budget.amount || 0;
  
          return {
            id: budget && budget.id,
            categoryName: budget.budgetCategory && budget.budgetCategory.categoryName || "",
            amount:totalAmount,
            subCategory: budget.budgetCategory && budget.budgetCategory.subCategories && budget.budgetCategory.subCategories[0] && budget.budgetCategory.subCategories[0].name || "",
          };
        });
        setMonthsBudgetData(structuredData);        
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllBudgetsMonthsCategory();
  }, []);

  return (
    <div
      className="create-main-card-conatiner"
      style={{ position: "relative" }}
    >
      {" "}
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <div className="budget-chart-title">Enter Budget for Next 12 Months</div>
        <ToolTipCreator name={"Budget_Enter_Budget_Next_12_Months"}/>
      </div>
      <div className="create-budget-tabs">
        {createBudgetTabs &&
          createBudgetTabs.map((item, index) => (
            <div
              key={index}
              className={
                index === selectedIndex ? "active-create-tab" : "create-tab"
              }
              onClick={() => {
                setSelectedIndex(index);
              }}
            >
              {item.name}
            </div>
          ))}
      </div>
      <div className="budget-create-fields-container">
        {selectedIndex === 0 ? (
          <div className="budget-fields">
            <div className="input-checkbox-container">
              <input
                type="checkbox"
                name="prefillBudget"
                id="prefillBudget"
                checked={prefillBudget}
                onChange={handleCheckboxChange}
              />
              <label className="checkbox-label" htmlFor="prefillBudget">
                Pre-fill from Previous 12 Months
              </label>
            </div>

            {getNext12Months().map((month, idx) => (
              <div>
                <label className="input-month-label">{month}:</label>
                <div key={idx} className="inputWrapper-create-budget">
                  <span className="input-dollar-sign">$</span>
                  <InputNumber
                    step={1}
                    value={
                      formData &&
                      formData[`amount-${month}`] &&
                      formData[`amount-${month}`]
                    }
                    formatter={(value) =>
                      value
                        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : ""
                    }
                    style={{ border: "none", background: "#f6f6f6" }}
                    parser={(value) => value.replace(/,/g, "")}
                    className="Input"
                    placeholder="Amount"
                    name={`amount-${month}`}
                    id={`amount-${month}`}
                    onChange={(value) =>
                      setFormData((prev) => ({
                        ...prev,
                        [`amount-${month}`]: value,
                      }))
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            className="inputWrapper-create-budget"
            style={{ display: "flex" }}
          >
            <span className="input-dollar-sign">$</span>
            <InputNumber
              step={1}
              value={formData && formData[`amount`] && formData[`amount`]}
              formatter={(value) =>
                value
                  ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : ""
              }
              style={{ border: "none", background: "#f6f6f6" }}
              parser={(value) => value.replace(/,/g, "")}
              className="Input"
              placeholder="Amount"
              name="amount"
              id="Amount"
              onChange={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  amount: value,
                }))
              }
            />
          </div>
        )}
      </div>
      <div className="budget-create-buttons-conatiner">
        <button
          className="budget-create-cancel"
          onClick={() => {
            setFormData({});
            setPrefillBudget(false);
          }}
        >
          Cancel
        </button>
        <button
          className="budget-create-save"
          onClick={() => {
            handleCreateBudget();
          }}
        >
          Save
        </button>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
